import messages from "messages";
import { ComponentPropsWithoutRef, useMemo } from "react";
import NoteCodeLayout from "../note-code-layout";
import NoteCode from "../note-code/NoteCode";
import { CPT_CODES, CPT_TYPE_LABELS } from "constants/cptCodes";

const CPT_CODES_WITHOUT_ADDON = CPT_CODES.filter((el) => el.type === "BASIC");

const DEFAULT = Object.freeze({ id: "", description: "", type: "" });
type Props = {
  codes: CPTCode[];
  onUpdateCodes: (arg: CPTCode[]) => void;
};

const CPTCodes = ({ codes = [], onUpdateCodes }: Props) => {
  const cptCodes: ComponentPropsWithoutRef<typeof NoteCode>["sortedCodes"] =
    useMemo(() => {
      if (!codes.length) {
        // placeholder
        return [DEFAULT] as (typeof DEFAULT & typeof CPT_CODES[number])[];
      }

      return codes.map((el) => {
        const matched = CPT_CODES.find((each) => each.id === el);

        return {
          ...DEFAULT,
          id: el,
          type: !matched ? messages.others : matched.type,
          description: matched?.description || "",
        };
      });
    }, [codes]);

  /**
   * options without existing code ids
   */
  const cptCodesOptions = useMemo(
    () => ({
      // cptCodesWithoutAddon: CPT_CODES_WITHOUT_ADDON.filter(
      //   (el) => !codes.includes(el.id),
      // ),
      // cptCodes: CPT_CODES.filter((el) => !codes.includes(el.id)),

      // Dr. Nibras says same code can be entered multiple times
      cptCodesWithoutAddon: CPT_CODES_WITHOUT_ADDON,
      cptCodes: CPT_CODES,
    }),
    [],
  );

  return (
    <NoteCodeLayout title={messages.clientService} label={messages.cptCode}>
      {cptCodes.map((el, i) => (
        <NoteCode
          labelTypes={CPT_TYPE_LABELS}
          key={el.id + i || i}
          code={el}
          sortedCodes={
            i === 0 || cptCodes.every((el) => !el.id)
              ? cptCodesOptions.cptCodesWithoutAddon
              : cptCodesOptions.cptCodes
          }
          onCreate={() => onUpdateCodes([...codes, ""])}
          onUpdate={(nextCode) =>
            onUpdateCodes([
              ...codes.slice(0, i),
              nextCode.id,
              ...codes.slice(i + 1),
            ])
          }
          onDelete={
            !!el.id || cptCodes.length > 1 || i !== 0
              ? () =>
                  onUpdateCodes([...codes.slice(0, i), ...codes.slice(i + 1)])
              : undefined
          }
          placeholder={messages.searchByProcedure}
        />
      ))}
    </NoteCodeLayout>
  );
};

export default CPTCodes;
